module.exports = __webpack_public_path__ + "static/media/ju1.69e6f05f.jpg";